import i18next, { type i18n as I18nInstance } from 'i18next'

import en from './translations/en.json' with { type: 'json' }
import es from './translations/es.json' with { type: 'json' }
import fr from './translations/fr.json' with { type: 'json' }
import ja from './translations/ja.json' with { type: 'json' }
import ko from './translations/ko.json' with { type: 'json' }
import ru from './translations/ru.json' with { type: 'json' }
import tr from './translations/tr.json' with { type: 'json' }
import zh from './translations/zh.json' with { type: 'json' }

/** Locales bundled with the RN SDK. */
export const localeMapping = {
  en: 'en',
  zh: 'zh',
  ko: 'ko',
  ja: 'ja',
  tr: 'tr',
  es: 'es',
  ru: 'ru',
  fr: 'fr',
} as const
export type Locale = keyof typeof localeMapping

// Private instance, deliberately NOT shared with @funkit/connect's i18n:
// - importing the SDK must never init/mutate the host app's i18next singleton
// - react-i18next's provider/initReactI18next are skipped (their context and
//   globals would collide with the host's) — components bind this instance via
//   useFunkitTranslation, and tagged copy via FunkitTrans
export const i18n: I18nInstance = i18next.createInstance()

void i18n.init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    ko: { translation: ko },
    ja: { translation: ja },
    tr: { translation: tr },
    es: { translation: es },
    ru: { translation: ru },
    fr: { translation: fr },
  },
  lng: 'en',
  fallbackLng: 'en',
  // Resources are bundled, so init synchronously — `t` is usable on import.
  initImmediate: false,
  interpolation: {
    escapeValue: false, // React already escapes interpolated values
  },
  // <Trans> would otherwise emit DOM `<br>`/`<strong>` hosts, which RN can't mount.
  react: { transSupportBasicHtmlNodes: false },
})
